module.exports = "/assets/c4c29225d8e1683de1684f1727eeacae.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/RI.png
// module id = 1788
// module chunks = 0